const defaultUrl = '//api-web-wan-ssl.xunlei.com'
const loginWanUrl = '//api-login-wan-ssl.xunlei.com'
const giftWanUrl = '//api-gift-wan-ssl.xunlei.com'
const userWanUrl = '//api-user-wan-ssl.xunlei.com'
export const urlMap = {
  playLeftAd: { url: '/v1/advertising/game_left_ad_1' },
  playLeftAdCountDown: { url: '/v1/game/play/countdown/30min' },
  payAd: { url: '/v1/advertising/game_pay_page_ad' },
  playLeftAdConfig: { url: '/v1/game/play/page/config' },
  notice: { url: '/v1/game/resource/notice' },
  playGameTopAd: { url: '/v1/advertising/game_top' },
  allGameSearch: { url: '/v1/game/list/all_game_search' },
  userInfo: { url: '/v1/user/info' },
  gameLatest: { url: '/v1/user/game/latest' },
  gameRecently: { url: '/v1/user/game/recently', data: { type: 'all' } },
  rebateGame: { url: '/v1/activity_new/list' },
  hotRecommend: { url: '/v1/game/list/hot_recommend', data: { count: 3 } },
  welfareAct: { url: '/v1/activity/list', data: { act_type: 1, count: 3 } },
  gameWelfare: { url: '/v1/activity/list' },
  popAct: { url: '/v1/activity/list', data: { act_type: 2, count: 1 } },
  giftGames: { url: '/v1/game/card/list', data: { page: 1, page_size: 20 } },
  sideBarNewServer: {
    url: '/v1/game/server/list',
    data: { open_status: 2, page_size: 3 }
  },
  newServer: {
    url: '/v1/game/server/list_v2',
    data: { open_status: 1, page_size: 20 }
  },
  getNewServer: {
    url: '/v1/game/newserver'
  },
  newOpenServer: {
    url: '/v1/game/server/list_v2',
    data: { open_status: 2, page_size: 20 }
  },
  gameServerList: {
    url: '/v1/game/server/list',
    data: { open_status: 2, page: 1, page_size: 500 }
  },
  cateServerList: { url: '/v1/category/game/server/list' },
  gameServerRandomList: {
    url: '/v1/game/random',
    data: { page: 1, page_size: 3 }
  },
  gameHomePopups: {
    url: '/v1/game/home/popups',
    method: 'get'
  },
  hotWebGame: {
    url: '/v1/game/list/hot_web_game',
    data: { count: 6 }
  },
  actRec: {
    url: '/v1/game/list/activity_recommend',
    data: { count: 3 }
  },
  gameRank: {
    url: '/v1/game/list/rank_game_recommend',
    data: { count: 9 }
  },
  homeBanner: {
    url: '/v1/game/list/home_banner',
    data: { count: 1 }
  },
  homeLeftAd: {
    url: '/v1/advertising/home_left_ad'
  },
  gameTopToolbarAd: {
    url: '/v1/advertising/game_top_toolbar_ad'
  },
  gameLeftToolbarAd: {
    url: '/v1/advertising/game_left_toolbar_ad'
  },
  getTime: {
    url: '/sys/attachment'
  },
  homeSlice: {
    url: '/v1/game/list/home_slice'
  },
  homeRec: {
    url: '/v1/game/list/guess_like',
    data: { count: 8 }
  },
  personalRec: {
    url: '/v1/game/list/profile_recommend',
    data: { count: 3 }
  },
  allGameRec: {
    url: '/v1/game/list/all_game_recommend',
    data: { count: 3 }
  },
  allGameCategory: {
    url: '/v1/category/list',
    data: { category_type: '1,2,3,4' }
  },
  allGameList: {
    url: '/v1/category/game/list'
  },
  gameRole: {
    url: '/v1/user/game/role'
  },
  payOrder: {
    url: '/v1/pay/order',
    method: 'post'
  },
  checkOrder: {
    url: '/v1/pay/order'
  },
  gameLogin: {
    url: '/v1/user/game/login',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { client_type: 'web' },
    server: loginWanUrl
  },
  gameHome: { url: '/v1/game/home' },
  gameHomeRes: { url: '/v1/game/home/res' },
  gameResDetail: { url: '/v1/game/home/detail' },
  giftCard: { url: '/v1/activity/user/gift', showNotify: true },
  postGift: { url: '/v1/activity/user/gift', method: 'post' },
  userCouponCodes: {
    url: '/v1/gift/queryUserValidCouponList',
    server: giftWanUrl
  },
  couponCode: { url: '/v1/gift/getStaticCodeCoupon', server: giftWanUrl },
  userGiftList: { url: '/v1/gift/queryUserGiftList', server: giftWanUrl },
  userGiftCount: { url: '/v1/gift/queryUserGiftCount', server: giftWanUrl },
  payOrderList: { url: '/v1/pay/order/list' },
  gameLoginReport: { url: '/v1/user/login/report', server: loginWanUrl },
  couponPay: { url: '/v1/pay/coupon', method: 'post', showNotify: true },
  // pay pop
  getRoleByGid: { url: '/v1/user/game/gid/role' },
  // gifts pages
  giftsTopBoard: {
    url: '/v1/gift/queryTopPackageList',
    server: giftWanUrl
  },
  giftsPackageList: { url: '/v1/gift/queryPackageList', server: giftWanUrl },
  giftsPackageListCount: {
    url: '/v1/gift/queryPackageCount',
    server: giftWanUrl
  },
  getGamePackage: {
    url: '/v1/gift/getGamePackage',
    server: giftWanUrl,
    needLogin: true
  },
  giftPackageDetail: { url: '/v1/gift/queryPackage', server: giftWanUrl },
  // vip rights
  activeUserExp: {
    url: '/v1/usercenter/activeExp',
    server: userWanUrl,
    showNotify: true
  },
  queryUserLevel: { url: '/v1/usercenter/queryUserLevel', server: userWanUrl },
  getUserExpDetail: {
    url: '/v1/usercenter/getXwUserExpDetailsList',
    server: userWanUrl
  },
  sendGiftRecharge: {
    url: '/v1/usercenter/sendGiftRecharge',
    server: userWanUrl
  },
  queryGiftRecharge: {
    url: '/v1/usercenter/queryGiftRecharge',
    server: userWanUrl
  },
  queryGiftRechargeCount: {
    url: '/v1/usercenter/queryGiftRechargeCount',
    server: userWanUrl
  },
  userExpCarousel: { url: '/v1/game/list/userexp_carousel' },
  userExpBanner: { url: '/v1/game/list/userexp_banner', data: { count: 3 } },
  postPlatformInfo: { url: '/v1/user/platform/info', method: 'post' }
}

function convertMap() {
  const map = {}
  for (const key in urlMap) {
    map[getUrl(key)] = key
  }
  return map
}

export default function getUrl(key) {
  const map = urlMap[key]
  if (map) {
    return (map.server || defaultUrl) + map.url
  }
  return key
}

export const urlToKey = convertMap()
